(function($, undefined) {
	
	'use strict';
	var formValidator;
	var addToCartBtn;
	var toggleShopItemDetailsBtn;

	// var addToCart = function() {
	// 	var t = $(this);
	// 	var id = t.attr('data-id');
	// 	var form = t.closest('.add-shop-item-form');
	// 	var qtyInput = form.find('input[name="quantity"]');

	// 	console.log(qtyInput.val());
	// 	formValidator.validateForm(form);

	// 	if (!form.hasClass('has-error')) {
	// 		var url = '/action/shopAddCart';
			
	// 		url += '?productId=' + id;
	// 		url += '&quantity=' + qtyInput.val();
	// 		url += '&override=true&data=true&ajax=true';

	// 		t.addClass('disabled');
			
	// 		var obj = ajax(url,function (response) {
	// 			console.log(response);
	// 			t.removeClass('disabled');
	// 			window.location.href = window.location.href;
	// 			// form.find('input').val('').removeClass('has-value');
	// 			// form.find('.forgot-pw-success').slideDown(function() {
	// 			// 	setTimeout(function() {
	// 			// 		form.find('.forgot-pw-success').slideUp();
	// 			// 	}, 5000);
	// 			// });
	// 		},true);
	// 	}
	// };

	var toggleDetails = function() {
		$(this).closest('.shop-item-extra-infos-ctn').find('.shop-item-extra-infos-inner-ctn').slideToggle();
	};

	var init = function () {
		formValidator = Fw.component.models().form;
		// addToCartBtn = $('.add-to-cart-btn');
		toggleShopItemDetailsBtn = $('.toggle-shop-details');

		// addToCartBtn.click(addToCart);
		toggleShopItemDetailsBtn.click(toggleDetails);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
